import { commonShortNouns } from "./common-short-fields";

export const platformAdminApplications = {
  title: "业务入口",
  subtitle: "统一管理业务入口状态、门户跳转与接入状态。",
  summaryTotal: "入口总数：{count}",
  summaryOnline: "在线：{count}",
  summaryDegraded: "降级：{count}",
  summaryOffline: "离线：{count}",
  summaryUnknown: "未知：{count}",
  summaryPlanning: "规划中：{count}",
  summaryDraft: "草稿接入：{count}",
  summaryOnboarding: "接入中：{count}",
  summaryInvalidated: "失效触发：{count}",
  summaryWarning: "预警入口：{count}",
  summaryCritical: "严重入口：{count}",
  summaryRemediation: "待整改入口：{count}",
  summaryRemediationCritical: "高优先整改：{count}",
  tableTitle: "业务入口清单",
  tableSubtitle: "面向考试与靶场业务的统一入口目录。",
  searchPlaceholder: "搜索入口/域名/说明",
  filterAll: "全部 {count}",
  filterOnline: "在线 {count}",
  filterDegraded: "降级 {count}",
  filterOffline: "离线 {count}",
  filterUnknown: "未知 {count}",
  drawerTitle: "{name} · 详情",
  providerStatusTitle: "业务底座依赖",
  accessControlTitle: "身份接入状态",
  invalidationTitle: "失效策略",
  remediationTitle: "整改建议",
  providerModeLabel: "模式：{value}",
  providerPhaseLabel: "阶段：{value}",
  providerDependenciesLabel: "依赖：{value}",
  accessConfigured: "已配置",
  accessMissing: "未配置",
  accessRiskHealthy: "无风险",
  accessRiskExpired: "已过期：{count}",
  accessRiskExpiringSoon: "即将过期：{count}",
  accessFields: {
    state: "接入状态",
    applicationStatus: "入口状态",
    rule: "命中规则",
    ruleDescription: "规则说明",
    reasons: "状态原因",
    grants: "授权规则",
    roleMappings: "角色映射",
    activeCredentials: "有效凭据",
    credentialRisk: "凭据风险",
  },
  invalidationFields: {
    triggers: "触发条件",
    effects: "生效结果",
    warningDays: "预警天数",
    severity: "告警等级",
  },
  remediationFields: {
    priority: "整改优先级",
    reasons: "整改原因",
    actions: "建议动作",
  },
  authConfigAction: "登录方式配置",
  authConfigTitle: "{name} · 登录方式配置",
  authConfigTitleShort: "登录方式配置",
  authConfigExamAdmin: "管理端登录方式",
  authConfigCandidate: "考生端登录方式",
  authConfigEntryModes: "入口登录方式覆盖",
  authConfigAddEntryMode: "新增入口配置",
  authConfigEntryKey: "入口键",
  authConfigEntryKeyPlaceholder: "例如 exam_admin / candidate / user / operator",
  authConfigEntryMode: "入口登录方式",
  authConfigSaved: "登录方式配置已保存",
  severities: {
    normal: "正常",
    warning: "预警",
    critical: "严重",
  },
  accessStates: {
    draft: "草稿",
    onboarding: "接入中",
    active: "已接入",
    degraded: "降级",
    blocked: "阻断",
    revoked: "已撤销",
  },
  undefinedAccessState: "未定义访问状态",
  accessReasons: {
    missing_access_configuration: "缺少接入配置",
    missing_active_credentials: "缺少有效凭据",
    credentials_expired: "存在过期凭据",
    credentials_expiring_soon: "存在即将过期凭据",
    application_status_not_active: "应用状态不是 active",
    all_credentials_revoked: "凭据已全部撤销",
  },
  undefinedAccessReason: "未定义访问原因",
  invalidationEffects: {
    none: "未触发失效",
    degraded_access: "降级访问",
    blocked_access: "阻断访问",
    revoked_access: "撤销访问",
  },
  undefinedInvalidationEffect: "未定义失效影响",
  remediationActions: {
    none: "当前无需整改",
    configure_access_grants: "补齐访问授权",
    configure_role_mappings: "补齐角色映射",
    issue_active_credentials: "签发有效凭据",
    rotate_expiring_credentials: "轮换临期凭据",
    replace_expired_credentials: "替换过期凭据",
    reactivate_application: "恢复应用状态",
  },
  undefinedRemediationAction: "未定义整改动作",
  fields: {
    name: "应用名称",
    status: "运行状态",
    domain: "域名",
    endpoint: "入口地址",
    note: "业务说明",
  },
  table: {
    app: "应用",
    domain: "域名",
    note: "业务说明",
    status: commonShortNouns.status,
    latency: "延迟",
    actions: commonShortNouns.actions,
  },
} as const;
